export default class Player {
    id: string;
    relatedScene: Phaser.Scene;
    type: string;
    color: number;
    noCollisionGroup: number;
    population: number;
    supply: number;

    // Constants
    static readonly humanType: string = 'human';
    static readonly computerType: string = 'computer';
    static readonly neutralType: string = 'neutral';

    constructor(id: string, scene: Phaser.Scene, type: string, color: number) {
        this.id = id;
        this.relatedScene = scene;
        this.type = type;
        this.color = color;
        this.noCollisionGroup = scene.matter.world.nextGroup(true);
        this.population = 0;
        this.supply = 0;
    }

    increasePopulation(population: number) {
        this.population = this.population + population;
        if(this.id === 'Player') {
            this.relatedScene.registry.events.emit('playerPopulationUpdated', population);
        }
    }

    decreasePopulation(population: number) {
        this.population = this.population - population;
        if(this.id === 'Player') {
            this.relatedScene.registry.events.emit('playerPopulationUpdated', -population);
        }
    }

    increaseSupply(supply: number) {
        if(this.supply == -1) {
            return;
        }

        this.supply = this.supply + supply;
        if(this.id === 'Player') {
            this.relatedScene.registry.events.emit('playerSupplyUpdated', supply);
        }
    }

    decreaseSupply(supply: number) {
        if(this.supply == -1) {
            return;
        }

        this.supply = this.supply - supply;
        if(this.id === 'Player') {
            this.relatedScene.registry.events.emit('playerSupplyUpdated', -supply);
        }
    }
}